module.exports = __webpack_public_path__ + "img/pdf.9e39b466.png";